import { render, staticRenderFns } from "./uploadPayVoucher.vue?vue&type=template&id=3cc13bce&scoped=true"
import script from "./uploadPayVoucher.vue?vue&type=script&lang=js"
export * from "./uploadPayVoucher.vue?vue&type=script&lang=js"
import style0 from "./uploadPayVoucher.vue?vue&type=style&index=0&id=3cc13bce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cc13bce",
  null
  
)

export default component.exports